// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { actionsStyles } from "@awc/Overrides/Widgets/ProductList/ProductListActions";
import { mergeWithCss } from "@awc/XDL/Utilities";
import { css } from "styled-components";

actionsStyles.wrapper = {
    ...mergeWithCss(actionsStyles.wrapper, {
        css: css`
            gap: 4px;
        `,
    }),
};

actionsStyles.actionButtons = {
    css: css`
        margin: 6px 0 10px 0;
        display: flex;
        flex-direction: column;
        row-gap: 8px;
    `,
};

actionsStyles.productListCompareAddToListWrapper = {
    wrapper: {
        css: css`
            flex-direction: row;
            justify-content: space-between;
            margin-top: 4px;
        `,
    },
    compareCheckbox: {
        css: css`
            padding-top: 0;
        `,
    },
};
